import React from "react";
import { Card, Col, Row } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  FileDoneOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const kpiStyles = {
  card: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: "100%",
    minHeight: 104,
    borderRadius: 14,
    border: "1px solid #f0f0f0",
    boxShadow: "0 10px 24px rgba(17, 48, 97, 0.08)",
  },
  body: {
    padding: 18,
    height: "100%",
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  iconBox: {
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 14,
    fontSize: 23,
  },
  value: {
    color: "#111827",
    fontSize: 30,
    fontWeight: 700,
    lineHeight: 1,
    letterSpacing: "-0.04em",
  },
  title: {
    marginTop: 7,
    color: "#6b7280",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.2,
    minHeight: 29,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
};

const KpiCard = ({ title, value, icon, loading }) => (
  <Card loading={loading} style={kpiStyles.card} bodyStyle={kpiStyles.body}>
    <div style={kpiStyles.content}>
      <div
        style={{
          ...kpiStyles.iconBox,
          color: "#4b5563",
          backgroundColor: "#f3f4f6",
        }}
      >
        {icon}
      </div>
      <div>
        <div style={kpiStyles.value}>{Number(value).toLocaleString("es-MX")}</div>
        <div style={kpiStyles.title}>{title}</div>
      </div>
    </div>
  </Card>
);

export default function IndicadoresComplementos({ indicadores, proveedores, loading }) {
  const proveedoresPendientes = proveedores.filter((item) => Number(item.diferencia || 0) > 0).length;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={6} style={{ display: "flex" }}>
        <KpiCard
          title="Facturas pagadas"
          value={indicadores.facturasPagadas || 0}
          icon={<CheckCircleOutlined />}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6} style={{ display: "flex" }}>
        <KpiCard
          title="Con complemento pago"
          value={indicadores.conComplementoPago || 0}
          icon={<FileDoneOutlined />}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6} style={{ display: "flex" }}>
        <KpiCard
          title="Pendientes"
          value={indicadores.pendientes || 0}
          icon={<ClockCircleOutlined />}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6} style={{ display: "flex" }}>
        <KpiCard
          title="Proveedores con pendiente"
          value={proveedoresPendientes}
          icon={<TeamOutlined />}
          loading={loading}
        />
      </Col>
    </Row>
  );
}
